import { useEffect, useRef } from "react";
import { startSSE, stopSSE } from "../../services/sseService";
import { getNotification } from "../../slices/Notification/GetNotification/thunk";
import { useDispatch } from "react-redux";
// import { addNotification } from "../../redux/notificationsSlice";

const NotificationListener = () => {
  const connectedRef = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("NotificationListener Mounted");

    // Request browser notification permission
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        console.log("Notification Permission:", permission);
      });
    }

    return () => {
      console.log("NotificationListener Unmounted");
    };
  }, []);

  const getNotificationMessage = (data) => {
    const quantity =
      data.StockInQuantity || data.StockOutQuantity || data.NetQuantity;

    const location =
      data.FromLocationName || data.ToLocationName || "the selected location";

    switch (data.type) {
      case "StockInRequest":
        return {
          title: "Purchase Order Request",
          body: `A purchase order request for ${quantity} units of ${data.itemName} from ${location}. Review and approve the request.`,
        };

      case "StockOutRequest":
        return {
          title: "Sales Order Request",
          body: `A sales order request for ${quantity} units of ${data.itemName} from ${location}. Review and approve the request.`,
        };

      default:
        return {
          title: "Approval Required",
          body: `A request for ${data.itemName} is awaiting your approval.`,
        };
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");

      if (!token || connectedRef.current) {
        return;
      }

      connectedRef.current = true;

      console.log("Starting SSE");

      startSSE(token, (notification) => {
        console.log("Notification Received:", notification);

        // Future Redux storage
        // dispatch(addNotification(notification));

        console.log("Permission:", Notification.permission);

        const { title, body } = getNotificationMessage(notification);

        // Browser Notification
        if ("Notification" in window && Notification.permission === "granted") {
          dispatch(getNotification());
          console.log("Creating browser notification");

          const browserNotification = new Notification(
            title || "Notification",
            {
              body,
              // tag: Date.now().toString(),
              // requireInteraction: true,
            }
          );

          browserNotification.onclick = () => {
            console.log("Notification clicked");

            window.focus();
            window.location.href = "/notifications";

            browserNotification.close();
          };
        }
      });
    }, 2000);

    return () => {
      clearInterval(interval);
      connectedRef.current = false;
      stopSSE();
    };
  }, []);

  return null;
};

export default NotificationListener;
